import { render } from "./AppSearch.vue?vue&type=template&id=bdab17f2"
import script from "./AppSearch.vue?vue&type=script&lang=js"
export * from "./AppSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__